// store/formSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  formElements: [],
};

const formSlice = createSlice({
  name: "form",
  initialState,
  reducers: {
    updateElement(state, action) {
      const updatedElements = [...state.formElements];
      console.log("in form slice");
      console.log(updatedElements);
      console.log(action.payload.id);
      console.log(action.payload.element);
      const index = updatedElements.findIndex(
        (el) => el.elementId === action.payload.id
      );

      console.log(index);
      if (index === -1) {
        updatedElements.push(action.payload.element);
      } else {
        updatedElements[index] = action.payload.element;
      }
      console.log("after updated...");
      console.log(updatedElements);
      return { ...state, formElements: updatedElements };
    },
  },
});

export const formElements = (state) => state.form.formElements;
export const { updateElement } = formSlice.actions;
export default formSlice.reducer;
